import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Grid,
  Paper,
  Typography,
  makeStyles,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Divider,
  TextField,
  Button,
  CircularProgress,
  IconButton,
  Chip,
  Badge,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  Avatar,
  Box,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Container,
  Fab,
  Tabs,
  Tab,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Checkbox,
  FormControlLabel
} from '@material-ui/core';
import {
  Search as SearchIcon,
  Business as BusinessIcon,
  LocationOn as LocationIcon,
  Add as AddIcon,
  FindInPage as FindInPageIcon,
  GetApp as GetAppIcon,
  Refresh as RefreshIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Map as MapIcon,
  Domain as DomainIcon,
  Label as LabelIcon,
  Close as CloseIcon,
  Assessment as AssessmentIcon,
  Home as HomeWorkIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  Link as LinkIcon
} from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: '#f5f5f5',
    minHeight: '100vh'
  },
  header: {
    background: 'linear-gradient(45deg, #516e76 30%, #accacd 90%)',
    color: 'white',
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(3),
    boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)'
  },
  headerTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1)
  },
  statsContainer: {
    marginBottom: theme.spacing(3)
  },
  statCard: {
    height: '100%',
    transition: 'transform 0.2s, box-shadow 0.2s',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[8]
    }
  },
  statNumber: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: theme.palette.primary.main
  },
  statLabel: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1)
  },
  filterSection: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    backgroundColor: 'white'
  },
  searchField: {
    marginBottom: theme.spacing(2)
  },
  propertyCard: {
    marginBottom: theme.spacing(2),
    transition: 'all 0.3s',
    '&:hover': {
      boxShadow: theme.shadows[8],
      transform: 'translateY(-2px)'
    }
  },
  matchedCard: {
    marginBottom: theme.spacing(2),
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.12)'
    }
  },
  matchColumn: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`
  },
  tableContainer: {
    marginTop: theme.spacing(2),
    boxShadow: theme.shadows[2],
    borderRadius: theme.spacing(1)
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    '& .MuiTableCell-head': {
      color: theme.palette.common.white,
      fontWeight: 600,
      fontSize: '0.875rem',
      borderBottom: 'none'
    }
  },
  tableRow: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  confidenceBadge: {
    fontWeight: 'bold',
    padding: '4px 8px',
    borderRadius: '4px',
    display: 'inline-block',
    minWidth: '60px',
    textAlign: 'center'
  },
  propertyHeader: {
    background: theme.palette.grey[50]
  },
  propertyName: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  branchChip: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    fontWeight: 'bold'
  },
  reasonChip: {
    margin: theme.spacing(0.5)
  },
  addressBox: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  actionButton: {
    margin: theme.spacing(0.5)
  },
  dialogContent: {
    minWidth: 500,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto'
    }
  },
  jobsiteItem: {
    transition: 'background-color 0.2s',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
    '&.selected': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText
    }
  },
  matchScore: {
    backgroundColor: theme.palette.success.main,
    color: 'white',
    padding: '2px 8px',
    borderRadius: 12,
    fontSize: '0.75rem',
    fontWeight: 'bold'
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(6)
  },
  emptyStateIcon: {
    fontSize: 80,
    color: theme.palette.success.main,
    marginBottom: theme.spacing(2)
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    left: theme.spacing(2)
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 1000
  },
  tabPanel: {
    paddingTop: theme.spacing(2)
  },
  expandedRow: {
    backgroundColor: theme.palette.grey[50]
  },
  inlineSearchContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `2px solid ${theme.palette.primary.main}`
  },
  inlineJobsiteItem: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    transition: 'all 0.2s',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main
    }
  }
}));

const AspirePropertiesManager = ({ auth }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [unmatchedProperties, setUnmatchedProperties] = useState([]);
  const [matchedProperties, setMatchedProperties] = useState([]);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [filteredMatchedProperties, setFilteredMatchedProperties] = useState([]);
  const [allJobsites, setAllJobsites] = useState([]);
  const [entities, setEntities] = useState([]);
  const [viewMode, setViewMode] = useState('unmatched'); // 'unmatched' or 'matched'
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [unmatchedPage, setUnmatchedPage] = useState(0);
  const [unmatchedRowsPerPage, setUnmatchedRowsPerPage] = useState(10);
  const [expandedRow, setExpandedRow] = useState(null);
  const [inlineSearchQuery, setInlineSearchQuery] = useState('');
  const [inlineMatchingJobsites, setInlineMatchingJobsites] = useState([]);

  // Contact conflict dialog states
  const [contactConflictDialog, setContactConflictDialog] = useState(false);
  const [existingContactData, setExistingContactData] = useState(null);
  const [pendingPropertyForCreation, setPendingPropertyForCreation] = useState(null);
  const [shouldActivateClient, setShouldActivateClient] = useState(false);
  const [statistics, setStatistics] = useState({
    total: 0,
    no_jobsites_for_branch: 0,
    no_matches_found: 0,
    below_threshold: 0
  });
  const [matchedStatistics, setMatchedStatistics] = useState({
    total: 0,
    highConfidence: 0,
    mediumConfidence: 0,
    lowConfidence: 0
  });

  // Filter states
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedBranch, setSelectedBranch] = useState('all');
  const [selectedReason, setSelectedReason] = useState('all');
  const [tabValue, setTabValue] = useState(0);
  const [matchedConfidenceFilter, setMatchedConfidenceFilter] = useState('all'); // 'all', 'high', 'medium', 'low'

  // Dialog states
  const [matchDialogOpen, setMatchDialogOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedJobsite, setSelectedJobsite] = useState(null);
  const [jobsiteSearchQuery, setJobsiteSearchQuery] = useState('');
  const [matchingJobsites, setMatchingJobsites] = useState([]);

  // Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  // Show snackbar helper
  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  // Load unmatched properties
  const loadUnmatchedProperties = useCallback(async (skipSync = false) => {
    try {
      const response = await axios.get('/api/aspire/properties/unmatched');
      if (response.data.success) {
        setUnmatchedProperties(response.data.unmatchedProperties || []);
        setFilteredProperties(response.data.unmatchedProperties || []);
        setStatistics(response.data.statistics || {});
      } else if (response.data.message?.includes('No sync data available')) {
        // Don't automatically sync - just show a message
        showSnackbar('No sync data available. Click Sync to load properties.', 'info');
      } else {
        showSnackbar('Failed to load properties', 'error');
      }
    } catch (error) {
      console.error('Error loading properties:', error);
      showSnackbar('Error loading unmatched properties', 'error');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, []);

  // Internal sync function to avoid circular deps
  const syncPropertiesInternal = async () => {
    try {
      setRefreshing(true);
      showSnackbar('Syncing properties from Aspire...', 'info');

      // Trigger live sync from Aspire API
      const syncResponse = await axios.get('/api/aspire/properties/sync', {
        params: {
          branchIds: [4, 5], // Default branches
          autoUpdate: false,
          generateReport: false,
          maxGeoDistance: 50,
          minAddressScore: 0.8,
          minNameScore: 0.6
        }
      });

      if (syncResponse.data.success) {
        showSnackbar(`Sync complete: ${syncResponse.data.summary.matched} matched, ${syncResponse.data.unmatchedCount} unmatched`, 'success');
        // After sync, load both matched and unmatched properties
        await loadUnmatchedProperties(true); // skip sync to avoid loop
        await loadMatchedProperties();
      } else {
        throw new Error(syncResponse.data.error || 'Sync failed');
      }
    } catch (error) {
      console.error('Error syncing properties:', error);
      showSnackbar(`Sync failed: ${error.message}`, 'error');
      setRefreshing(false);
    }
  };

  // Sync properties from Aspire (public wrapper)
  const syncProperties = useCallback(() => {
    syncPropertiesInternal();
  }, []);

  // Load matched properties
  const loadMatchedProperties = useCallback(async () => {
    try {
      const response = await axios.get('/api/aspire/properties/matched');
      if (response.data.success) {
        setMatchedProperties(response.data.matchedProperties || []);
        setFilteredMatchedProperties(response.data.matchedProperties || []);
        setMatchedStatistics(response.data.statistics || {});
      }
    } catch (error) {
      console.error('Error loading matched properties:', error);
    }
  }, []);

  // Load all jobsites
  const loadJobsites = useCallback(async () => {
    try {
      const response = await axios.get('/api/aspire/properties/jobsites');
      if (response.data.success) {
        setAllJobsites(response.data.jobsites || []);
      }
    } catch (error) {
      console.error('Error loading jobsites:', error);
    }
  }, []);

  // Load entities for branch mapping
  const loadEntities = useCallback(async () => {
    try {
      const response = await axios.get('/api/aspire/properties/entities');
      if (response.data.success) {
        setEntities(response.data.branchMap || {});
      }
    } catch (error) {
      console.error('Error loading entities:', error);
    }
  }, []);

  useEffect(() => {
    loadUnmatchedProperties();
    loadMatchedProperties();
    loadJobsites();
    loadEntities();
  }, [loadUnmatchedProperties, loadMatchedProperties, loadJobsites, loadEntities]);

  // Filter properties (unmatched)
  useEffect(() => {
    let filtered = [...unmatchedProperties];

    // Search filter
    if (searchQuery) {
      filtered = filtered.filter(item => {
        const prop = item.property;
        const query = searchQuery.toLowerCase();
        return (
          prop.PropertyName?.toLowerCase().includes(query) ||
          prop.PropertyNameAbr?.toLowerCase().includes(query) ||
          prop.PropertyAddressLine1?.toLowerCase().includes(query) ||
          prop.PropertyAddressCity?.toLowerCase().includes(query)
        );
      });
    }

    // Branch filter
    if (selectedBranch !== 'all') {
      filtered = filtered.filter(item =>
        item.property.BranchID == selectedBranch
      );
    }

    // Reason filter
    if (selectedReason !== 'all') {
      filtered = filtered.filter(item =>
        item.reason === selectedReason
      );
    }

    // Tab filter
    if (tabValue === 1) {
      filtered = filtered.filter(item =>
        item.reason === 'no_jobsites_for_branch'
      );
    } else if (tabValue === 2) {
      filtered = filtered.filter(item =>
        item.reason === 'no_matches_found'
      );
    } else if (tabValue === 3) {
      filtered = filtered.filter(item =>
        item.reason === 'below_threshold'
      );
    }

    setFilteredProperties(filtered);
  }, [searchQuery, selectedBranch, selectedReason, tabValue, unmatchedProperties]);

  // Filter matched properties by confidence
  useEffect(() => {
    let filtered = [...matchedProperties];

    // Confidence filter
    if (matchedConfidenceFilter !== 'all') {
      filtered = filtered.filter(match => {
        if (matchedConfidenceFilter === 'high') {
          return match.status === 'high_confidence';
        } else if (matchedConfidenceFilter === 'medium') {
          return match.status === 'medium_confidence';
        } else if (matchedConfidenceFilter === 'low') {
          return match.status === 'low_confidence';
        }
        return true;
      });
    }

    setFilteredMatchedProperties(filtered);
  }, [matchedConfidenceFilter, matchedProperties]);


  // Handle refresh - triggers live sync
  const handleRefresh = () => {
    syncProperties();
  };

  // Open match dialog
  const openMatchDialog = (property) => {
    setSelectedProperty(property);
    setSelectedJobsite(null);
    setJobsiteSearchQuery('');
    setMatchingJobsites([]);
    setMatchDialogOpen(true);
  };

  // Handle create jobsite - check for existing contacts first
  const handleCreateJobsite = async (property) => {
    try {
      // First check if contact already exists
      if (property.PropertyContacts && property.PropertyContacts.length > 0) {
        const checkResponse = await axios.post('/api/aspire/properties/check-contact', {
          propertyContacts: property.PropertyContacts
        });

        if (checkResponse.data.exists) {
          // Contact exists - show conflict dialog
          setExistingContactData(checkResponse.data);
          setPendingPropertyForCreation(property);
          setContactConflictDialog(true);
          return;
        }
      }

      // No existing contact found - create directly
      await createJobsiteWithClient(property, null, false);
    } catch (error) {
      console.error('Error checking/creating jobsite:', error);
      showSnackbar(`Failed: ${error.response?.data?.error || error.message}`, 'error');
    }
  };

  // Actually create the jobsite with chosen client option
  const createJobsiteWithClient = async (property, existingClientId, forceNewClient) => {
    try {
      const response = await axios.post('/api/aspire/properties/create-jobsite', {
        name: property.PropertyName || property.PropertyNameAbr,
        address: property.PropertyAddressLine1,
        address2: property.PropertyAddressLine2,
        city: property.PropertyAddressCity,
        state: property.PropertyAddressState,
        zip: property.PropertyAddressZip,
        latitude: property.Latitude || property.GEOLocationLatitude,
        longitude: property.Longitude || property.GEOLocationLongitude,
        aspirePropertyId: property.PropertyID,
        aspireBranchId: property.BranchID,
        propertyContacts: property.PropertyContacts || [],
        notes: `Created from Aspire Property ID: ${property.PropertyID}`,
        useExistingClientId: existingClientId,
        createNewClient: forceNewClient,
        activateClient: shouldActivateClient
      });

      if (response.data.success) {
        let message = `Jobsite created: ${response.data.jobsite.name}`;
        if (response.data.client) {
          message += ` with client: ${response.data.client.displayName}`;
        }
        showSnackbar(message, 'success');

        // Close dialog and reset state
        setContactConflictDialog(false);
        setExistingContactData(null);
        setPendingPropertyForCreation(null);
        setShouldActivateClient(false);

        // Reload data
        loadUnmatchedProperties();
        loadMatchedProperties();
        loadJobsites();
      }
    } catch (error) {
      console.error('Error creating jobsite:', error);
      showSnackbar(`Failed to create jobsite: ${error.response?.data?.error || error.message}`, 'error');
    }
  };

  // Search jobsites
  useEffect(() => {
    if (!jobsiteSearchQuery || jobsiteSearchQuery.length < 2) {
      setMatchingJobsites([]);
      return;
    }

    const query = jobsiteSearchQuery.toLowerCase();
    const matches = allJobsites.filter(jobsite => {
      return (
        jobsite.name?.toLowerCase().includes(query) ||
        jobsite.address?.toLowerCase().includes(query) ||
        jobsite.city?.toLowerCase().includes(query)
      );
    }).slice(0, 10);

    // Calculate match scores
    const scoredMatches = matches.map(jobsite => {
      let score = 0;
      const prop = selectedProperty?.property;

      if (prop && jobsite.name && prop.PropertyName) {
        const nameSimilarity = calculateSimilarity(
          jobsite.name.toLowerCase(),
          prop.PropertyName.toLowerCase()
        );
        score = Math.max(score, nameSimilarity);
      }

      if (prop && jobsite.address && prop.PropertyAddressLine1) {
        const addressSimilarity = calculateSimilarity(
          jobsite.address.toLowerCase(),
          prop.PropertyAddressLine1.toLowerCase()
        );
        score = Math.max(score, addressSimilarity * 0.9);
      }

      return { ...jobsite, matchScore: Math.min(score * 100, 100) };
    });

    scoredMatches.sort((a, b) => b.matchScore - a.matchScore);
    setMatchingJobsites(scoredMatches);
  }, [jobsiteSearchQuery, allJobsites, selectedProperty]);

  // Inline search for jobsites (for expanded row)
  useEffect(() => {
    if (!inlineSearchQuery || inlineSearchQuery.length < 2) {
      setInlineMatchingJobsites([]);
      return;
    }

    const query = inlineSearchQuery.toLowerCase();
    const matches = allJobsites.filter(jobsite => {
      return (
        jobsite.name?.toLowerCase().includes(query) ||
        jobsite.address?.toLowerCase().includes(query) ||
        jobsite.city?.toLowerCase().includes(query)
      );
    }).slice(0, 5);

    // Calculate match scores based on expanded row property
    const expandedProperty = unmatchedProperties.find(p => p.property.PropertyID === expandedRow);
    const scoredMatches = matches.map(jobsite => {
      let score = 0;
      const prop = expandedProperty?.property;

      if (prop && jobsite.name && prop.PropertyName) {
        const nameSimilarity = calculateSimilarity(
          jobsite.name.toLowerCase(),
          prop.PropertyName.toLowerCase()
        );
        score = Math.max(score, nameSimilarity);
      }

      if (prop && jobsite.address && prop.PropertyAddressLine1) {
        const addressSimilarity = calculateSimilarity(
          jobsite.address.toLowerCase(),
          prop.PropertyAddressLine1.toLowerCase()
        );
        score = Math.max(score, addressSimilarity * 0.9);
      }

      return { ...jobsite, matchScore: Math.min(score * 100, 100) };
    });

    scoredMatches.sort((a, b) => b.matchScore - a.matchScore);
    setInlineMatchingJobsites(scoredMatches);
  }, [inlineSearchQuery, allJobsites, expandedRow, unmatchedProperties]);

  // Calculate string similarity (simple Levenshtein)
  const calculateSimilarity = (str1, str2) => {
    if (str1 === str2) return 1;
    const longer = str1.length > str2.length ? str1 : str2;
    const shorter = str1.length > str2.length ? str2 : str1;
    if (longer.length === 0) return 1.0;
    const editDistance = getEditDistance(longer, shorter);
    return (longer.length - editDistance) / longer.length;
  };

  const getEditDistance = (str1, str2) => {
    const matrix = [];
    for (let i = 0; i <= str2.length; i++) {
      matrix[i] = [i];
    }
    for (let j = 0; j <= str1.length; j++) {
      matrix[0][j] = j;
    }
    for (let i = 1; i <= str2.length; i++) {
      for (let j = 1; j <= str1.length; j++) {
        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1,
            matrix[i][j - 1] + 1,
            matrix[i - 1][j] + 1
          );
        }
      }
    }
    return matrix[str2.length][str1.length];
  };

  // Confirm match
  const confirmMatch = async () => {
    if (!selectedProperty || !selectedJobsite) {
      showSnackbar('Please select a jobsite to match', 'error');
      return;
    }

    try {
      const response = await axios.post('/api/aspire/properties/update-match', {
        jobsiteId: selectedJobsite._id,
        propertyId: selectedProperty.property.PropertyID,
        confidence: 1.0
      });

      if (response.data.success) {
        showSnackbar('Property matched successfully!', 'success');
        setMatchDialogOpen(false);
        loadUnmatchedProperties();
        loadMatchedProperties();
      } else {
        showSnackbar('Failed to match property', 'error');
      }
    } catch (error) {
      console.error('Error matching property:', error);
      showSnackbar('Error matching property', 'error');
    }
  };

  // Inline match function
  const handleInlineMatch = async (propertyId, jobsite) => {
    try {
      const response = await axios.post('/api/aspire/properties/update-match', {
        jobsiteId: jobsite._id,
        propertyId: propertyId,
        confidence: 1.0
      });

      if (response.data.success) {
        showSnackbar(`Matched to ${jobsite.name}!`, 'success');
        setExpandedRow(null);
        setInlineSearchQuery('');
        setInlineMatchingJobsites([]);
        loadUnmatchedProperties();
        loadMatchedProperties();
      } else {
        showSnackbar('Failed to match property', 'error');
      }
    } catch (error) {
      console.error('Error matching property:', error);
      showSnackbar('Error matching property', 'error');
    }
  };

  // Toggle expanded row
  const toggleExpandRow = (propertyId) => {
    if (expandedRow === propertyId) {
      setExpandedRow(null);
      setInlineSearchQuery('');
      setInlineMatchingJobsites([]);
    } else {
      setExpandedRow(propertyId);
      setInlineSearchQuery('');
      setInlineMatchingJobsites([]);
    }
  };

  // Create new jobsite
  const createNewJobsite = async (property) => {
    if (!window.confirm(`Create a new jobsite for:\n${property.PropertyName || property.PropertyNameAbr}?`)) {
      return;
    }

    try {
      const response = await axios.post('/api/aspire/properties/create-jobsite', {
        name: property.PropertyName || property.PropertyNameAbr,
        address: property.PropertyAddressLine1,
        address2: property.PropertyAddressLine2,
        city: property.PropertyAddressCity,
        state: property.PropertyAddressStateProvinceCode,
        zip: property.PropertyAddressZipCode,
        latitude: property.GEOLocationLatitude,
        longitude: property.GEOLocationLongitude,
        aspirePropertyId: property.PropertyID,
        aspireBranchId: property.BranchID,
        notes: `Created from Aspire Property ID: ${property.PropertyID}`
      });

      if (response.data.success) {
        showSnackbar('Jobsite created successfully!', 'success');
        loadUnmatchedProperties();
      } else {
        showSnackbar(response.data.error || 'Failed to create jobsite', 'error');
      }
    } catch (error) {
      console.error('Error creating jobsite:', error);
      showSnackbar('Error creating jobsite', 'error');
    }
  };

  // Export to Excel
  const exportToExcel = async () => {
    try {
      const response = await axios.get('/api/aspire/properties/export-unmatched');
      if (response.data.success && response.data.reportPath) {
        window.open(response.data.reportPath, '_blank');
        showSnackbar('Excel report generated!', 'success');
      } else {
        showSnackbar('Failed to generate report', 'error');
      }
    } catch (error) {
      console.error('Error generating report:', error);
      showSnackbar('Error generating report', 'error');
    }
  };

  // Get reason color
  const getReasonColor = (reason) => {
    switch (reason) {
      case 'no_jobsites_for_branch':
        return 'error';
      case 'no_matches_found':
        return 'warning';
      case 'below_threshold':
        return 'info';
      default:
        return 'default';
    }
  };

  // Get reason icon
  const getReasonIcon = (reason) => {
    switch (reason) {
      case 'no_jobsites_for_branch':
        return <ErrorIcon />;
      case 'no_matches_found':
        return <WarningIcon />;
      case 'below_threshold':
        return <WarningIcon />;
      default:
        return <WarningIcon />;
    }
  };

  // Handle table pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Format property contacts
  const formatContacts = (contacts) => {
    if (!contacts || contacts.length === 0) return 'No contacts';

    const primaryContact = contacts.find(c => c.PrimaryContact);
    const billingContact = contacts.find(c => c.BillingContact);

    if (primaryContact) {
      return (
        <Box>
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            {primaryContact.ContactName}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {primaryContact.PrimaryContact && '(Primary) '}
            {primaryContact.BillingContact && '(Billing)'}
          </Typography>
        </Box>
      );
    } else if (billingContact) {
      return (
        <Box>
          <Typography variant="body2">
            {billingContact.ContactName}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            (Billing)
          </Typography>
        </Box>
      );
    } else {
      return (
        <Typography variant="body2">
          {contacts[0].ContactName}
          {contacts.length > 1 && ` +${contacts.length - 1} more`}
        </Typography>
      );
    }
  };

  // Render confidence badge
  const renderConfidenceBadge = (match) => {
    const confidence = (match.confidence * 100).toFixed(0);
    let backgroundColor = '#4caf50'; // green
    if (match.status === 'medium_confidence') backgroundColor = '#ff9800'; // orange
    if (match.status === 'low_confidence') backgroundColor = '#f44336'; // red

    return (
      <span
        className={classes.confidenceBadge}
        style={{ backgroundColor, color: 'white' }}
      >
        {confidence}%
      </span>
    );
  };

  // Render unmatched properties table
  const renderUnmatchedPropertiesTable = () => {
    const paginatedProperties = filteredProperties.slice(
      unmatchedPage * unmatchedRowsPerPage,
      unmatchedPage * unmatchedRowsPerPage + unmatchedRowsPerPage
    );

    const handleUnmatchedChangePage = (event, newPage) => {
      setUnmatchedPage(newPage);
    };

    const handleUnmatchedChangeRowsPerPage = (event) => {
      setUnmatchedRowsPerPage(parseInt(event.target.value, 10));
      setUnmatchedPage(0);
    };

    return (
      <>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table>
            <TableHead className={classes.tableHeader}>
              <TableRow>
                <TableCell>Aspire Property</TableCell>
                <TableCell>Aspire Address</TableCell>
                <TableCell>City, State, Zip</TableCell>
                <TableCell>Aspire Contact</TableCell>
                <TableCell>Aspire Branch</TableCell>
                <TableCell>Property ID</TableCell>
                <TableCell>Reason Not Matched</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading || refreshing ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Box py={4}>
                      <CircularProgress />
                      <Typography variant="body2" style={{ marginTop: 16 }}>
                        Loading unmatched properties...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : paginatedProperties.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <Box py={4}>
                      <Typography variant="body1" color="textSecondary">
                        No unmatched properties found
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                paginatedProperties.map((item) => {
                const prop = item.property;
                const reasonDisplay = item.reason.replace(/_/g, ' ').toUpperCase();
                const isExpanded = expandedRow === prop.PropertyID;

                let reasonColor = '#f44336'; // red
                if (item.reason === 'no_matches_found') reasonColor = '#ff9800'; // orange
                if (item.reason === 'below_threshold') reasonColor = '#2196f3'; // blue

                return (
                  <React.Fragment key={prop.PropertyID}>
                    <TableRow className={classes.tableRow}>
                      <TableCell>
                        <Typography variant="body2" style={{ fontWeight: 500 }}>
                          {prop.PropertyName || prop.PropertyNameAbr || 'Unnamed Property'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {prop.PropertyAddressLine1}
                          {prop.PropertyAddressLine2 && `, ${prop.PropertyAddressLine2}`}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {prop.PropertyAddressCity}, {prop.PropertyAddressState} {prop.PropertyAddressZip}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {formatContacts(prop.PropertyContacts)}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={`Branch ${prop.BranchID || 'N/A'}`}
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {prop.PropertyID}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={reasonDisplay}
                          size="small"
                          style={{
                            backgroundColor: reasonColor,
                            color: 'white',
                            fontWeight: 500
                          }}
                        />
                        {item.bestMatch && (
                          <Tooltip title={`Best match: ${item.bestMatch.name} (${(item.bestMatch.score * 100).toFixed(0)}%)`}>
                            <IconButton size="small">
                              <FindInPageIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title={isExpanded ? "Close inline search" : "Search for match inline"}>
                          <IconButton
                            size="small"
                            color={isExpanded ? "secondary" : "primary"}
                            onClick={() => toggleExpandRow(prop.PropertyID)}
                          >
                            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Create New Jobsite">
                          <IconButton
                            size="small"
                            color="secondary"
                            onClick={() => handleCreateJobsite(prop)}
                          >
                            <AddIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                    {isExpanded && (
                      <TableRow className={classes.expandedRow}>
                        <TableCell colSpan={8} style={{ paddingBottom: 0, paddingTop: 0 }}>
                          <Box className={classes.inlineSearchContainer}>
                            <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 600 }}>
                              <LinkIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: 4 }} />
                              Search Portal Jobsites to Match
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              variant="outlined"
                              placeholder="Type to search jobsites by name or address..."
                              value={inlineSearchQuery}
                              onChange={(e) => setInlineSearchQuery(e.target.value)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <SearchIcon />
                                  </InputAdornment>
                                )
                              }}
                              style={{ marginBottom: 12 }}
                            />
                            {inlineSearchQuery.length >= 2 && (
                              <Box>
                                {inlineMatchingJobsites.length === 0 ? (
                                  <Typography variant="body2" color="textSecondary">
                                    No matching jobsites found
                                  </Typography>
                                ) : (
                                  <Box>
                                    {inlineMatchingJobsites.map(jobsite => (
                                      <Box
                                        key={jobsite._id}
                                        className={classes.inlineJobsiteItem}
                                        onClick={() => handleInlineMatch(prop.PropertyID, jobsite)}
                                      >
                                        <Grid container spacing={2} alignItems="center">
                                          <Grid item xs={12} sm={5}>
                                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                                              {jobsite.name || 'Unnamed Jobsite'}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                              AG ID: {jobsite.agId}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={12} sm={5}>
                                            <Typography variant="caption">
                                              {jobsite.address}, {jobsite.city} {jobsite.state}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={12} sm={2} style={{ textAlign: 'right' }}>
                                            {jobsite.matchScore > 0 && (
                                              <Chip
                                                label={`${Math.round(jobsite.matchScore)}%`}
                                                size="small"
                                                style={{
                                                  backgroundColor: jobsite.matchScore > 70 ? '#4caf50' : '#ff9800',
                                                  color: 'white',
                                                  fontWeight: 'bold'
                                                }}
                                              />
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    ))}
                                  </Box>
                                )}
                              </Box>
                            )}
                            {inlineSearchQuery.length < 2 && (
                              <Typography variant="caption" color="textSecondary">
                                Type at least 2 characters to search
                              </Typography>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                );
              }))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={filteredProperties.length}
          rowsPerPage={unmatchedRowsPerPage}
          page={unmatchedPage}
          onChangePage={handleUnmatchedChangePage}
          onChangeRowsPerPage={handleUnmatchedChangeRowsPerPage}
        />
      </>
    );
  };

  // Render matched properties table
  const renderMatchedPropertiesTable = () => {
    const paginatedProperties = matchedProperties.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    return (
      <>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table>
            <TableHead className={classes.tableHeader}>
              <TableRow>
                <TableCell>Confidence</TableCell>
                <TableCell>Aspire Property</TableCell>
                <TableCell>Aspire Address</TableCell>
                <TableCell>Aspire Contact</TableCell>
                <TableCell>Portal Entity</TableCell>
                <TableCell>Portal Jobsite</TableCell>
                <TableCell>Portal Client</TableCell>
                <TableCell>Portal Address</TableCell>
                <TableCell>Match Type</TableCell>
                <TableCell>Distance</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading || refreshing ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <Box py={4}>
                      <CircularProgress />
                      <Typography variant="body2" style={{ marginTop: 16 }}>
                        Loading matched properties...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : paginatedProperties.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <Box py={4}>
                      <Typography variant="body1" color="textSecondary">
                        No matched properties found
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                paginatedProperties.map((match, index) => {
                const property = match.property;
                const jobsite = match.jobsite;
                const entityName = jobsite.entity?.name || `Branch ${property.BranchID}`;

                return (
                  <TableRow key={`${property.PropertyID}-${jobsite._id}`} className={classes.tableRow}>
                    <TableCell>
                  {renderConfidenceBadge(match)}
                  {match.confidence >= 1.0 && (
                    <Tooltip title="Auto-matched at 100% confidence">
                      <CheckCircleIcon
                        fontSize="small"
                        style={{ color: '#4caf50', marginLeft: 4, verticalAlign: 'middle' }}
                      />
                    </Tooltip>
                  )}
                  {match.confidence < 1.0 && (
                    <Tooltip title="Requires human review">
                      <WarningIcon
                        fontSize="small"
                        style={{ color: '#ff9800', marginLeft: 4, verticalAlign: 'middle' }}
                      />
                    </Tooltip>
                  )}
                </TableCell>
                    <TableCell>
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        {property.PropertyName || property.PropertyNameAbr}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        ID: {property.PropertyID}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {property.PropertyAddressLine1}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {property.PropertyAddressCity}, {property.PropertyAddressState} {property.PropertyAddressZip}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {formatContacts(property.contacts)}
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={entityName}
                        size="small"
                        color="primary"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        {jobsite.name}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        AG: {jobsite.agId}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        {jobsite.client?.displayName || 'No Client'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {jobsite.address}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {jobsite.city}, {jobsite.state} {jobsite.zip}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {match.matchType?.map((type, i) => (
                        <Chip
                          key={i}
                          label={type}
                          size="small"
                          style={{ marginRight: 4, marginBottom: 4 }}
                        />
                      ))}
                    </TableCell>
                    <TableCell>
                      {match.geoDistance !== undefined ? (
                        <Typography variant="body2">
                          {match.geoDistance.toFixed(0)}m
                        </Typography>
                      ) : '-'}
                    </TableCell>
                  </TableRow>
                );
              }))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={matchedProperties.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </>
    );
  };

  // Render property card (keeping the old card rendering for unmatched)
  const renderMatchedPropertyCard = (match) => {
    const property = match.property;
    const jobsite = match.jobsite;
    const confidence = (match.confidence * 100).toFixed(0);

    return (
      <Card key={`${property.PropertyID}-${jobsite._id}`} className={classes.matchedCard} elevation={2}>
        <CardHeader
          avatar={
            <Badge
              badgeContent={`${confidence}%`}
              color={
                match.status === 'high_confidence' ? 'primary' :
                match.status === 'medium_confidence' ? 'default' : 'error'
              }
            >
              <Avatar className={classes.avatar}>
                <CheckCircleIcon />
              </Avatar>
            </Badge>
          }
          title={
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" component="div">
                Match Confidence: {confidence}%
              </Typography>
              <Chip
                label={match.status.replace('_', ' ').toUpperCase()}
                size="small"
                color={
                  match.status === 'high_confidence' ? 'primary' :
                  match.status === 'medium_confidence' ? 'default' : 'error'
                }
              />
            </Box>
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            {/* Aspire Property Column */}
            <Grid item xs={12} md={6}>
              <Paper className={classes.matchColumn} elevation={0}>
                <Typography variant="subtitle2" color="primary" gutterBottom>
                  <BusinessIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  ASPIRE PROPERTY
                </Typography>
                <Divider style={{ marginBottom: 8 }} />

                <Typography variant="h6" gutterBottom>
                  {property.PropertyName || property.PropertyNameAbr}
                </Typography>

                <Box mt={1}>
                  <Typography variant="body2" color="textSecondary">
                    <LocationIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: 4 }} />
                    {property.PropertyAddressLine1}
                    {property.PropertyAddressLine2 && `, ${property.PropertyAddressLine2}`}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {property.PropertyAddressCity}, {property.PropertyAddressState} {property.PropertyAddressZip}
                  </Typography>
                </Box>

                <Box mt={2}>
                  <Typography variant="caption" color="textSecondary">
                    Property ID: {property.PropertyID}
                  </Typography>
                  <br />
                  <Typography variant="caption" color="textSecondary">
                    Branch: {property.BranchID}
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            {/* Portal Jobsite Column */}
            <Grid item xs={12} md={6}>
              <Paper className={classes.matchColumn} elevation={0}>
                <Typography variant="subtitle2" color="primary" gutterBottom>
                  <DomainIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  PORTAL JOBSITE
                </Typography>
                <Divider style={{ marginBottom: 8 }} />

                <Typography variant="h6" gutterBottom>
                  {jobsite.name}
                </Typography>

                <Box mt={1}>
                  <Typography variant="body2" color="textSecondary">
                    <LocationIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: 4 }} />
                    {jobsite.address}
                    {jobsite.address2 && `, ${jobsite.address2}`}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {jobsite.city}, {jobsite.state} {jobsite.zip}
                  </Typography>
                </Box>

                <Box mt={2}>
                  <Typography variant="caption" color="textSecondary">
                    AG ID: {jobsite.agId}
                  </Typography>
                  <br />
                  {jobsite.entity && (
                    <Typography variant="caption" color="textSecondary">
                      Entity: {jobsite.entity.name}
                    </Typography>
                  )}
                </Box>
              </Paper>
            </Grid>
          </Grid>

          {/* Match Details */}
          <Box mt={2} p={1} bgcolor="grey.100" borderRadius={1}>
            <Typography variant="caption" color="textSecondary">
              Match Type: {match.matchType?.join(', ')}
            </Typography>
            {match.geoDistance !== undefined && (
              <>
                <br />
                <Typography variant="caption" color="textSecondary">
                  Distance: {match.geoDistance.toFixed(1)} meters
                </Typography>
              </>
            )}
          </Box>
        </CardContent>
      </Card>
    );
  };

  const renderPropertyCard = (item) => {
    const prop = item.property;
    const reasonDisplay = item.reason.replace(/_/g, ' ').toUpperCase();
    const entityName = entities[prop.BranchID] || `Branch ${prop.BranchID || 'N/A'}`;

    return (
      <Grid item xs={12} md={6} lg={4} key={prop.PropertyID}>
        <Card className={classes.propertyCard}>
          <CardHeader
            className={classes.propertyHeader}
            title={
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" className={classes.propertyName}>
                  {prop.PropertyName || prop.PropertyNameAbr || 'Unnamed Property'}
                </Typography>
                <Chip
                  label={entityName}
                  className={classes.branchChip}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              </Box>
            }
            subheader={
              <Box display="flex" alignItems="center" mt={1}>
                <LocationIcon fontSize="small" style={{ marginRight: 4 }} />
                <Typography variant="caption">
                  Property ID: {prop.PropertyID}
                </Typography>
              </Box>
            }
          />
          <CardContent>
            <Box className={classes.addressBox}>
              <Typography variant="body2" color="textSecondary">
                {prop.PropertyAddressLine1 || ''}
                {prop.PropertyAddressLine2 ? <br /> : ''}
                {prop.PropertyAddressLine2 || ''}
                <br />
                {`${prop.PropertyAddressCity || ''}, ${prop.PropertyAddressStateProvinceCode || ''} ${prop.PropertyAddressZipCode || ''}`}
              </Typography>
            </Box>

            <Box display="flex" flexWrap="wrap" alignItems="center">
              <Chip
                icon={getReasonIcon(item.reason)}
                label={reasonDisplay}
                color={getReasonColor(item.reason)}
                className={classes.reasonChip}
                size="small"
              />
              {prop.IndustryName && (
                <Chip
                  icon={<BusinessIcon />}
                  label={prop.IndustryName}
                  className={classes.reasonChip}
                  size="small"
                  variant="outlined"
                />
              )}
            </Box>
          </CardContent>
          <Divider />
          <CardActions>
            <Button
              size="small"
              color="primary"
              startIcon={<FindInPageIcon />}
              onClick={() => openMatchDialog(item)}
              className={classes.actionButton}
            >
              Find Match
            </Button>
            <Button
              size="small"
              color="secondary"
              startIcon={<AddIcon />}
              onClick={() => createNewJobsite(prop)}
              className={classes.actionButton}
            >
              Create Jobsite
            </Button>
          </CardActions>
        </Card>
      </Grid>
    );
  };

  return (
    <Container maxWidth="xl" className={classes.root}>
      {/* Header */}
      <Paper className={classes.header} elevation={3}>
        <Typography variant="h4" className={classes.headerTitle}>
          <HomeWorkIcon style={{ verticalAlign: 'middle', marginRight: 12 }} />
          Aspire Property Sync Manager
        </Typography>
        <Typography variant="subtitle1" style={{ opacity: 0.95, marginBottom: 16 }}>
          Match and manage properties between Aspire and the Portal
        </Typography>

        {/* View Mode Toggle */}
        <Tabs
          value={viewMode}
          onChange={(e, newValue) => setViewMode(newValue)}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderRadius: 8 }}
        >
          <Tab
            label={`Unmatched (${statistics.total})`}
            value="unmatched"
            icon={<WarningIcon />}
          />
          <Tab
            label={`Matched (${matchedStatistics.total})`}
            value="matched"
            icon={<CheckCircleIcon />}
          />
        </Tabs>
      </Paper>

      {/* Statistics Cards */}
      {viewMode === 'unmatched' ? (
      <Grid container spacing={3} className={classes.statsContainer}>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statCard}>
            <CardContent>
              <Box textAlign="center">
                <Typography className={classes.statNumber}>
                  {statistics.total}
                </Typography>
                <Typography variant="subtitle2" className={classes.statLabel}>
                  Total Unmatched
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statCard}>
            <CardContent>
              <Box textAlign="center">
                <Typography className={classes.statNumber} style={{ color: '#f44336' }}>
                  {statistics.no_jobsites_for_branch}
                </Typography>
                <Typography variant="subtitle2" className={classes.statLabel}>
                  No Branch Sites
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statCard}>
            <CardContent>
              <Box textAlign="center">
                <Typography className={classes.statNumber} style={{ color: '#ff9800' }}>
                  {statistics.no_matches_found}
                </Typography>
                <Typography variant="subtitle2" className={classes.statLabel}>
                  No Matches Found
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statCard}>
            <CardContent>
              <Box textAlign="center">
                <Typography className={classes.statNumber} style={{ color: '#2196f3' }}>
                  {statistics.below_threshold}
                </Typography>
                <Typography variant="subtitle2" className={classes.statLabel}>
                  Below Threshold
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      ) : (
      <Grid container spacing={3} className={classes.statsContainer}>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statCard}>
            <CardContent>
              <Box textAlign="center">
                <Typography className={classes.statNumber}>
                  {matchedStatistics.total}
                </Typography>
                <Typography variant="subtitle2" className={classes.statLabel}>
                  Total Matched
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statCard}>
            <CardContent>
              <Box textAlign="center">
                <Typography className={classes.statNumber} style={{ color: '#4caf50' }}>
                  {matchedStatistics.highConfidence}
                </Typography>
                <Typography variant="subtitle2" className={classes.statLabel}>
                  High Confidence
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statCard}>
            <CardContent>
              <Box textAlign="center">
                <Typography className={classes.statNumber} style={{ color: '#ff9800' }}>
                  {matchedStatistics.mediumConfidence}
                </Typography>
                <Typography variant="subtitle2" className={classes.statLabel}>
                  Medium Confidence
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card className={classes.statCard}>
            <CardContent>
              <Box textAlign="center">
                <Typography className={classes.statNumber} style={{ color: '#f44336' }}>
                  {matchedStatistics.lowConfidence}
                </Typography>
                <Typography variant="subtitle2" className={classes.statLabel}>
                  Low Confidence
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      )}

      {/* Filters */}
      {viewMode === 'unmatched' && (
      <Paper className={classes.filterSection} elevation={2}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search properties..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Branch Filter</InputLabel>
              <Select
                value={selectedBranch}
                onChange={(e) => setSelectedBranch(e.target.value)}
                label="Branch Filter"
              >
                <MenuItem value="all">All Branches</MenuItem>
                <MenuItem value="4">Branch 4</MenuItem>
                <MenuItem value="5">Branch 5</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>Reason Filter</InputLabel>
              <Select
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
                label="Reason Filter"
              >
                <MenuItem value="all">All Reasons</MenuItem>
                <MenuItem value="no_jobsites_for_branch">No Jobsites in Branch</MenuItem>
                <MenuItem value="no_matches_found">No Matches Found</MenuItem>
                <MenuItem value="below_threshold">Below Threshold</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={2}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={handleRefresh}
              disabled={refreshing}
            >
              {refreshing ? 'Syncing...' : 'Sync'}
            </Button>
          </Grid>
        </Grid>

        {/* Tabs */}
        <Box mt={2}>
          <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={`All (${statistics.total})`} />
            <Tab label={`No Branch Sites (${statistics.no_jobsites_for_branch})`} />
            <Tab label={`No Matches (${statistics.no_matches_found})`} />
            <Tab label={`Low Score (${statistics.below_threshold})`} />
          </Tabs>
        </Box>
      </Paper>
      )}

      {/* Loading overlay for refresh */}
      {refreshing && (
        <Box mt={2} mb={2}>
          <LinearProgress />
        </Box>
      )}

      {/* Properties Table */}
      {viewMode === 'unmatched' ? (
        // Unmatched Properties View - Table Format
        renderUnmatchedPropertiesTable()
      ) : (
        // Matched Properties View - Table Format
        renderMatchedPropertiesTable()
      )}

      {/* Contact Conflict Dialog */}
      <Dialog
        open={contactConflictDialog}
        onClose={() => {
          setContactConflictDialog(false);
          setShouldActivateClient(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">
              <WarningIcon style={{ verticalAlign: 'middle', marginRight: 8, color: '#ff9800' }} />
              Existing Contact Found
            </Typography>
            <IconButton onClick={() => {
              setContactConflictDialog(false);
              setShouldActivateClient(false);
            }} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {existingContactData && (
            <>
              <Alert severity="warning" style={{ marginBottom: 16 }}>
                A contact matching the Aspire property contact already exists in the system.
                Please choose how to proceed:
              </Alert>

              <Box mb={2}>
                <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
                  Aspire Contact:
                </Typography>
                <Paper variant="outlined" style={{ padding: 12 }}>
                  <Typography variant="body2">
                    <strong>Name:</strong> {existingContactData.aspireContact.name}
                  </Typography>
                  {existingContactData.aspireContact.email && (
                    <Typography variant="body2">
                      <strong>Email:</strong> {existingContactData.aspireContact.email}
                    </Typography>
                  )}
                  {existingContactData.aspireContact.company && (
                    <Typography variant="body2">
                      <strong>Company:</strong> {existingContactData.aspireContact.company}
                    </Typography>
                  )}
                  <Box mt={1}>
                    {existingContactData.aspireContact.isPrimary && (
                      <Chip label="Primary Contact" size="small" color="primary" style={{ marginRight: 8 }} />
                    )}
                    {existingContactData.aspireContact.isBilling && (
                      <Chip label="Billing Contact" size="small" color="secondary" />
                    )}
                  </Box>
                </Paper>
              </Box>

              {existingContactData.existingContacts.length > 0 && (
                <Box mb={2}>
                  <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
                    Existing Portal Contacts:
                  </Typography>
                  <List>
                    {existingContactData.existingContacts.map((contact) => (
                      <ListItem key={contact._id} style={{ paddingLeft: 0 }}>
                        <ListItemAvatar>
                          <Avatar>
                            <BusinessIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={contact.name}
                          secondary={
                            <>
                              {contact.email && <span>Email: {contact.email}<br /></span>}
                              {contact.client && <span>Client: {contact.client.displayName}</span>}
                            </>
                          }
                        />
                        {contact.client && (
                          <ListItemSecondaryAction>
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => createJobsiteWithClient(
                                pendingPropertyForCreation,
                                contact.client._id,
                                false
                              )}
                            >
                              Use This Client
                            </Button>
                          </ListItemSecondaryAction>
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}

              {existingContactData.existingClients.length > 0 && (
                <Box mb={2}>
                  <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>
                    Or choose from existing clients:
                  </Typography>
                  <List>
                    {existingContactData.existingClients.map((client) => (
                      <ListItem key={client._id} style={{ paddingLeft: 0 }}>
                        <ListItemAvatar>
                          <Avatar style={{ backgroundColor: client.active === false ? '#f44336' : '#4caf50' }}>
                            <DomainIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Box display="flex" alignItems="center">
                              <span>{client.displayName}</span>
                              {client.active === false && (
                                <Chip
                                  label="INACTIVE"
                                  size="small"
                                  color="secondary"
                                  style={{ marginLeft: 8 }}
                                />
                              )}
                            </Box>
                          }
                          secondary={
                            <>
                              {client.companyName && <span>Company: {client.companyName}<br /></span>}
                              {client.email && <span>Email: {client.email}<br /></span>}
                              {client.agId && <span>AG ID: {client.agId}</span>}
                            </>
                          }
                        />
                        <ListItemSecondaryAction>
                          <Box display="flex" flexDirection="column" alignItems="flex-end">
                            {client.active === false && (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={shouldActivateClient}
                                    onChange={(e) => setShouldActivateClient(e.target.checked)}
                                    color="primary"
                                    size="small"
                                  />
                                }
                                label="Activate"
                                style={{ marginBottom: 4 }}
                              />
                            )}
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => createJobsiteWithClient(
                                pendingPropertyForCreation,
                                client._id,
                                false
                              )}
                            >
                              Use This Client
                            </Button>
                          </Box>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setContactConflictDialog(false);
            setShouldActivateClient(false);
          }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            startIcon={<AddIcon />}
            onClick={() => createJobsiteWithClient(pendingPropertyForCreation, null, true)}
          >
            Create New Client
          </Button>
        </DialogActions>
      </Dialog>

      {/* Match Dialog */}
      <Dialog
        open={matchDialogOpen}
        onClose={() => setMatchDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            Find Matching Jobsite
            <IconButton onClick={() => setMatchDialogOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="body2" paragraph>
            Search for an existing jobsite to match with:
            <strong> {selectedProperty?.property.PropertyName || selectedProperty?.property.PropertyNameAbr}</strong>
          </Typography>

          <TextField
            fullWidth
            variant="outlined"
            placeholder="Enter jobsite name or address..."
            value={jobsiteSearchQuery}
            onChange={(e) => setJobsiteSearchQuery(e.target.value)}
            style={{ marginBottom: 16 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
          />

          {jobsiteSearchQuery.length >= 2 && (
            <Paper variant="outlined">
              <List>
                {matchingJobsites.length === 0 ? (
                  <ListItem>
                    <ListItemText
                      primary="No matching jobsites found"
                      secondary="Try adjusting your search terms"
                    />
                  </ListItem>
                ) : (
                  matchingJobsites.map(jobsite => (
                    <ListItem
                      key={jobsite._id}
                      button
                      selected={selectedJobsite?._id === jobsite._id}
                      onClick={() => setSelectedJobsite(jobsite)}
                      className={selectedJobsite?._id === jobsite._id ? classes.jobsiteItem + ' selected' : classes.jobsiteItem}
                    >
                      <ListItemAvatar>
                        <Avatar>
                          <MapIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={jobsite.name || 'Unnamed Jobsite'}
                        secondary={
                          <>
                            {`${jobsite.address || ''}, ${jobsite.city || ''} ${jobsite.state || ''} ${jobsite.zip || ''}`}
                            {jobsite.entity?.name && (
                              <Typography variant="caption" display="block">
                                Entity: {jobsite.entity.name}
                              </Typography>
                            )}
                          </>
                        }
                      />
                      {jobsite.matchScore > 70 && (
                        <ListItemSecondaryAction>
                          <Chip
                            label={`${Math.round(jobsite.matchScore)}% match`}
                            className={classes.matchScore}
                            size="small"
                          />
                        </ListItemSecondaryAction>
                      )}
                    </ListItem>
                  ))
                )}
              </List>
            </Paper>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMatchDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={confirmMatch}
            color="primary"
            variant="contained"
            disabled={!selectedJobsite}
          >
            Confirm Match
          </Button>
        </DialogActions>
      </Dialog>

      {/* FAB for Excel Export */}
      <Fab
        color="secondary"
        className={classes.fab}
        onClick={exportToExcel}
      >
        <Tooltip title="Export to Excel">
          <GetAppIcon />
        </Tooltip>
      </Fab>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps)(AspirePropertiesManager);